module.exports = __webpack_public_path__ + "files/ff69abe779948171c2aaf1c5e951e32f.png";